import { AuthContext } from '@urbanx/agx.auth.client';
import { MenuTitles } from 'constants/menu';
import { useSelectedAgency } from 'hooks';
import { ContentLayout, PageLayout } from 'layout';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

const TeamPageLayout = () => {
  const { userAccount } = useContext(AuthContext);
  const { agency: selectedAgency } = useSelectedAgency();

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={selectedAgency?.name || ''}
      currentPageTitle={MenuTitles.USERS_AND_TEAMS}
    >
      <ContentLayout hasSecondaryMenu={true} secondaryActiveMenu={MenuTitles.USERS_AND_TEAMS}>
        <Outlet />
      </ContentLayout>
    </PageLayout>
  );
};

export default TeamPageLayout;
